import { POSITIONS } from "../flyout/constants";

export const SELECT_TYPES = {
  SINGLE: "single",
  MULTIPLE: "multiple",
} as const;

export const NOT_FOUND_LABEL_TEXT =
  "Значение не найдено. Попробуйте изменить запрос";

export const SELECT_POSITIONS = {
  [POSITIONS.BOTTOM_END]: POSITIONS.BOTTOM_END,
  [POSITIONS.BOTTOM_START]: POSITIONS.BOTTOM_START,
  [POSITIONS.BOTTOM]: POSITIONS.BOTTOM,
  [POSITIONS.TOP_END]: POSITIONS.TOP_END,
  [POSITIONS.TOP_START]: POSITIONS.TOP_START,
  [POSITIONS.TOP]: POSITIONS.TOP,
} as const;
